import React from "react";
import {
  Drawer,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Divider,
  Stack,
  styled,
} from "@mui/material";
import { Instagram, Telegram } from "@mui/icons-material";
import XIcon from "@mui/icons-material/X"; // Replace with the correct import
import { fontSizes } from "../../theme/font-sizes";
import { darkColors } from "../../theme/colors";
import { assetIcons } from "../../constants/assets";
import { socialRedirectUrls } from "../../constants/urls";
import englishTranslations from "../../i18n/translations/en";
import { useLocation, useNavigate } from "react-router-dom";
import routes from "../../constants/routes";
import InlineSvg from "../utils/inline-svg";
import FacebookIcon from "@mui/icons-material/Facebook";

const StyledDrawer = styled(Drawer)(({ isMediumScreen }) => ({
  "& .MuiDrawer-paper": {
    width: isMediumScreen ? "100%" : "25%",

    backgroundColor: isMediumScreen ? darkColors.background : "#1a1a1a",
    color: "#fff",
    borderRight: "1px solid #333",
    zIndex: 0,
  },
}));

const AccountSidebar = ({ isMediumScreen }) => {
  //   const drawerWidth = 240;
  const navigate = useNavigate();
  const location = useLocation();
  const sections = [
    {
      title: "USER SETTINGS",
      items: [
        {
          text: "Profile",
          icon: assetIcons.profileIcon,
          route: routes.account,
        },
        { text: "2FA", icon: assetIcons.shieldIcon, route: routes.security },
        // { text: "Privacy", icon: assetIcons.cctvIcon, route: routes.privacy },
      ],
    },
    {
      title: "PAYMENT SETTINGS",
      items: [
        { text: "Billing", icon: assetIcons.walletIcon, route: routes.billing },
        { text: "My Bets", icon: assetIcons.dice, route: routes.user_bets },
      ],
    },
  ];

  const socialIcons = [
    {
      name: "Discord",
      url: socialRedirectUrls.discord,
      component: <img src={assetIcons.discord} alt="discord" />,
    },
    {
      name: "Facebook",
      url: socialRedirectUrls.facebook,
      component: <FacebookIcon />,
    },
    { name: "Twitter", url: socialRedirectUrls.twitter, component: <XIcon /> },
    {
      name: "Tiktok",
      url: socialRedirectUrls.tiktok,
      component: (
        <img src={assetIcons.tiktok} alt="tiktok" width={30} height={30} />
      ),
    },
  ];
  const drawerWidth = isMediumScreen ? "100%" : "25%";

  return (
    <StyledDrawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
      }}
      isMediumScreen={isMediumScreen}
    >
      <Box
        pt={isMediumScreen ? 9 : 15}
        pl={isMediumScreen ? 2 : "35%"}
        textAlign={"left"}
        flex
        sx={{ overflowY: "auto", overflowX: "hidden", mt: 2 }}
      >
        {sections.map((section, index) => (
          <React.Fragment key={index}>
            <Typography
              fontSize={fontSizes.heading3}
              color={darkColors.tableGray}
              fontWeight={700}
              sx={{ px: 2 }}
            >
              {section.title}
            </Typography>
            <List>
              {section.items.map((item) => (
                <ListItem
                  button
                  key={item.text}
                  onClick={() => navigate(item.route)}
                  sx={{
                    cursor: "pointer",
                    width: "80%",
                    borderRadius: "12px",
                    backgroundColor:
                      location.pathname === item.route
                        ? "#252525"
                        : "transparent", // Gray background for active path
                  }}
                >
                  <InlineSvg
                    sx={{ width: 24, height: 24, marginRight: 10 }}
                    url={item.icon}
                    color={
                      location.pathname === item.route
                        ? darkColors.buttonTop
                        : "#838383"
                    }
                  />
                  <ListItemText
                    sx={{
                      color:
                        location.pathname === item.route ? "#fff" : "#838383", // White text for active path
                    }}
                    primaryTypographyProps={{
                      fontSize: fontSizes.heading3,
                      fontWeight: 700,
                    }}
                    primary={item.text}
                  />
                </ListItem>
              ))}
            </List>

            {index < sections.length && (
              <Divider
                sx={{ background: darkColors.gray, mt: 1, mb: 3, mr: 8, ml: 2 }}
              />
            )}
          </React.Fragment>
        ))}

        {/* Social Icons */}
        <Box
          sx={{
            position: "fixed",
            bottom: isMediumScreen ? "12%" : 0,
            left: isMediumScreen ? 15 : "8%",
            display: "flex",
            gap: 1,
          }}
        >
          <List>
            <Stack
              direction="row"
              display={"flex"}
              justifyContent={isMediumScreen ? "center" : "left"}
              spacing={isMediumScreen ? 2 : 1.5}
              sx={{ mb: 2, ml: isMediumScreen ? 0 : 2 }}
            >
              {socialIcons.map((icon) => (
                <IconButton
                  key={icon.name}
                  size="small"
                  sx={{ color: darkColors.socialIconsGray }}
                  onClick={() => window.open(icon.url, "_blank")}
                >
                  {icon.component}
                </IconButton>
              ))}
            </Stack>
            <Divider sx={{ background: darkColors.gray, mx: 2 }} />
            <Box
              sx={{
                width: isMediumScreen ? "90%" : "200px",
                ml: 2,
                mb: 2,
                mt: 2,
              }}
            >
              <Typography
                sx={{
                  textAlign: isMediumScreen ? "center" : "left",
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                  flexWrap: "wrap",
                  fontSize: "clamp(10px, 0.9vw, 14px)",
                  color: darkColors.gray,
                }}
              >
                {englishTranslations.planetJSidebar}
              </Typography>
            </Box>
          </List>
        </Box>
      </Box>
    </StyledDrawer>
  );
};

export default AccountSidebar;
